import api from 'utils/api'

export const emailValidate = async (payload) => await api.post('/cps/v1/verifyuserid', payload)
export const securitycode = async (payload) => await api.post('/cps/v1/sendsecuritycode', payload)
export const verifySecuritycode = async (payload) => await api.post('/cps/v1/verifysecuritycode', payload)
export const resetpassword = async (payload) => await api.post('/cps/v1/resetpassword', payload)
export const resendSecuritycode = async (payload) => await api.post('/cps/v1/resendsecuritycode', payload)
